import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpClient.service';
import { Observable } from 'rxjs';
import { cabinApi } from '../../constants/cabin-api';
import { PaginationType } from '../../interfaces/pagination/pagination-type';
import { permissionEntity } from '../../constants/permission';
import { PermissionsPipe } from '../../pipe/permissions.pipe';
import { specificUserParams, userParams } from '../../helpers/helperfunc';

@Injectable({
  providedIn: 'root'
})
export class CabinService {
    permissions_entity = permissionEntity;

    constructor(
        private httpClientService: HttpClientService,
        private _permissionPipe: PermissionsPipe // dont remove this
    ) {}

    getCabin(pagination: PaginationType, search?: string): Observable<any> {
        let query = '?';
        if (search) {
            query += `${search}`;
        }
        query += userParams.call(this, this.permissions_entity.modules.cabin);
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;
        return this.httpClientService.get(`${cabinApi.getCabins}${query}`);
    }

    postCabin(payload: any): Observable<any> {
        return this.httpClientService.post(
            cabinApi.createCabins,
            payload
        );
    }

    editCabin(id: any, payload: any): Observable<any> {
        return this.httpClientService.put(`${cabinApi.editCabins}?Id=${id}`, payload);
    }

    deleteCabin(id: any): Observable<any> {
        return this.httpClientService.delete(`${cabinApi.deteleCabins}?Id=${id}`);
    }
    postVoucher(payload: any): Observable<any> {
        return this.httpClientService.post(
            cabinApi.addVoucher,
            payload
        );
    }
    getVoucherUser(): Observable<any> {
        return this.httpClientService.get(`${cabinApi.getUserVoucher}`);
    }
    getVoucherCodes(): Observable<any> {
        return this.httpClientService.get(`${cabinApi.getVoucherCodes}`);
    }
    getVoucher(pagination: PaginationType, search?: string): Observable<any> {
        let query = '?';
        if (search) {
            query += `${search}`;
        }
        // query += userParams.call(this, this.permissions_entity.modules.cabin);
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;
        return this.httpClientService.get(`${cabinApi.getVoucherList}${query}`);
    }
    updateVoucherDetails(voucherId: string,payload): Observable<any> {
        return this.httpClientService.put(
          `${cabinApi.updatedVoucher}?voucherId=${voucherId}`,payload
        );
    }
    getVoucherList(): Observable<any> {
        return this.httpClientService.get(`${cabinApi.getVoucherListById}`);
    }

    postApplicationDeadline(payload: any): Observable<any> {
        return this.httpClientService.post(
            cabinApi.createDeadline,
            payload
        );
    }

    getApplicationDeadline(pagination: PaginationType, filters?: string): Observable<any> {
        let query = '?';
        if (filters) {
            query += filters;
        }
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;
        return this.httpClientService.get(
            `${cabinApi.createDeadline}${query}`,
        );
    }
    deleteApplicationDeadline(id: any): Observable<any> {
        return this.httpClientService.delete(
            `${cabinApi.createDeadline}?id=${id}`,
        );
    }
    editApplicationDeadline(id: any): Observable<any> {
        return this.httpClientService.get(
            `${cabinApi.editDeadline}${id}`,
        );
    }
    updatedApplicationDeadline(id: any,payload): Observable<any> {
        return this.httpClientService.put(`${cabinApi.createDeadline}?universityDeadlinesId=${id}`,payload)
    }

    getLoansData(pagination: PaginationType, search?: string): Observable<any> {
        let query = '?';
        if (search) {
            query += `${search}`;
        }
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;
        return this.httpClientService.get(`${cabinApi.getLoans}${query}`);
    }

    addLoanProvider(formData: any): Observable<any> {
        return this.httpClientService.upload(
            cabinApi.addLoanProvider,
            formData  
        );
    }

    updateLoanProvider(formData: any): Observable<any> {
        let query = '?';
        if (formData.get('_id')) {
            query += `id=${formData.get('_id')}`;
        }
        return this.httpClientService.upload(
            cabinApi.updateLoanProvider,
            formData
        );
    }

    getLoanById(_id: string): Observable<any> {
        return this.httpClientService.get(`${cabinApi.getLoans}/${_id}`);
    }
}
